import { handleError } from "@helpers"
import axios from "~axios"

/**
 * Extract filename without extension from URL
 * @param {string} url - File URL
 * @returns {string|null} - Filename without extension or null
 */
function getFilenameFromUrl(url) {
    try {
        const urlObj = new URL(url)
        const pathname = urlObj.pathname
        const filename = pathname.split("/").pop()

        if (!filename) {
            return null
        }

        // Remove file extension (everything after the last dot)
        const lastDotIndex = filename.lastIndexOf(".")
        return lastDotIndex > 0 ? filename.substring(0, lastDotIndex) : filename
    } catch (e) {
        // If URL is invalid, return null
        return null
    }
}

/**
 * Upload file by URL to file service
 * @param {string} url - File URL to upload
 * @param {string} model - Model type (default, coursePreview, etc.)
 * @param {string|null} name - File name (optional)
 * @returns {Promise<Object>} - Uploaded file data
 */
export async function uploadFileByUrl(url, model = "default", name = null) {
    // If name is not specified, extract filename from URL
    if (!name) {
        name = getFilenameFromUrl(url)
    }

    const formData = new FormData()
    formData.append("url", url)
    formData.append("name", name)

    if (window.current_cabinet_id) {
        formData.append("cabinet_id", window.current_cabinet_id)
    }

    const fileServiceUrl = window.file_storage_url.replaceAll(`/upload`, `/upload-by-url`) + `?model=${model}&upload=1`

    const response = await axios.post(fileServiceUrl, formData)
    return response.data.data
}

export default {
    methods: {
        // eslint-disable-next-line no-unused-vars
        async uploadByLink(url, name = null, unsplashId = null) {
            this.loading = true

            try {
                const data = await uploadFileByUrl(url, this.model, name)
                //
                //     if (unsplashId) {
                //         axios.post(`/unsplash/photos/${unsplashId}/download`)
                //     }
                //
                this.$emit("upload", data)
            } catch (error) {
                handleError(error)
            } finally {
                this.loading = false
            }
        }
    }
}
